/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Sent_OkInputs */

const cs_signing_sent_ok = /** @type {(inputs: Signing_Sent_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument odeslán k podpisu`)
};

const en_signing_sent_ok = /** @type {(inputs: Signing_Sent_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document sent for signing`)
};

/**
* | output |
* | --- |
* | "Document sent for signing" |
*
* @param {Signing_Sent_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_sent_ok = /** @type {((inputs?: Signing_Sent_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Sent_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_sent_ok(inputs)
	return cs_signing_sent_ok(inputs)
});